export default [
    {
      path: '/mng/account/contacts/contact',
      name: 'administrator',
      component: () => import('@/pages/mng/information/administrator/index.vue'),
      meta: {
        title: '企业管理员',
        // dataUrl: '/mng/account/embed/indexAjax?embed_type=weisheng',
      },
    },
    {
      path: '/mng/account/corpInfo',
      component: () => import('@/pages/mng/information/corpInfo/index.vue'),
      meta: {
        title: '企业资料',
      },
    },
  ];
